import {createSummaryData} from './subSectionMapping/subSections';
import {mappedHeaderValues, mappedHeaderSections} from './CbdHeaderDataMapping';
import pick from 'lodash.pick';

//maps data to sections within the UI
export const mapDataToUI = ui => {
  if (!ui || !ui.cbdHeader) return {};

  const headerData = mappedHeaderValues (ui.cbdHeader);

  const headerReferenceData = ['DEV STYLE',
  'COLORWAY',
  'PCC',
  'PRODUCTION FACTORY',
  'SEASON',
  'MILESTONE (GATE)',
  'QUOTE STATE',
  'Age Group',
  'Retail Price',
  'Product Code',
  'Dev Team',
  'Gender',
  'Ready for Review Date',
  'Costing Size',
  'Sample ID',
  'FOB Effective Date',
  'COSTING SEASON',
  'EARLY OR LATE BUY INDICATOR'];

  const boldReferenceCard = pick (headerData, [
    'DEV STYLE',
    'COLORWAY',
    'PCC',
    'PRODUCTION FACTORY',
    'SEASON',
    'MILESTONE (GATE)',
    'QUOTE STATE',
    'COSTING SEASON',
    'EARLY OR LATE BUY INDICATOR'
  ]);

  const plainReferenceCard = pick (headerData, [
    'Age Group',
    'Retail Price',
    'Product Code',
    'Dev Team',
    'Gender',
    'Ready for Review Date',
    'Costing Size',
    'Sample ID',
    'FOB Effective Date',
  ]);

  const SideBarSummaryData = pick (mappedHeaderSections (headerData), [
    //'Product Info',
    'Quote Info',
    'System Info',
  ]);

  const fobData = pick (headerData, [
    'Target FOB',
    'Target Tooling',
    'FOB',
    'FOB with Tooling',
    'Tooling Cost',
    'DUTY DRIVER',
    'ACTUAL DUTY DRIVER',
    'FOB Effective Date',
    'Target Material Cost',
    'Target Labor Cost',
    'Target Profit Cost',
    'Target Overhead Cost',
    'Target FOB with Tooling',
    'Total Standard Minutes',
    'Total Observed Minutes'
  ]);

  const headerDataForSummarySections = pick (headerData, [
    'FEM',
    'Factory Labor Rate',
    'Labor Rate Effective Date',
    'EXCHANGE RATE STATUS',
    'Labor Reference Date',
    'Material Reference Date',
    'Overhead Reference Date',
    'Other Overhead Percent',
    'Other Overhead Percent Effective Date',
    'Profit Reference Date',
    'FEM Effective Date',
    'Profit Rate Percent',
    'Profit Rate Percent Effective Date',
    'Other Adjustment Cost',
    'Other Cost',
    'Glidepath Cost',
    'Other Adjustment Cost Description',
    'Tooling Effective Date',
  ]);

  const SummarySectionData = createSummaryData (
    ui.cbdLineItems,
    ui.cbdHeader,
    fobData['FOB'],
    headerDataForSummarySections
  );

  const ExchangeRateData = pick (headerData, [
    'Cost Sheet Exchange Rate Effective Date',
    'Exchange Rates',
  ]);

  return {
    headerData,
    boldReferenceCard,
    plainReferenceCard,
    headerReferenceData,
    SideBarSummaryData,
    fobData,
    headerDataForSummarySections,
    SummarySectionData,
    ExchangeRateData,
  };
};



// WEBPACK FOOTER //
// ./src/dataMappingUIHelpers/uiMapping.js